import React, { useCallback, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { UserActivityCategory, UserActivityTypes } from '@pascal/iframe-service';

import { useStore, useTranslation } from '../../../../../hooks';
import { formatDate, formatValue } from '../../../../../helpers';
import { T } from '../../../../../constants';

interface SidebarFreebetCardProps {
  onClose: () => void;
}
export const SidebarFreebetCard: React.FC<SidebarFreebetCardProps> = observer(({ onClose }) => {
  const { freeSpinStore, userActivityStore, gameStore } = useStore();
  const { currencySymbol, hasGameRedirection } = gameStore;
  const translate = useTranslation();
  const {
    showFreeSpinReward,
    showAllFreeSpinRewards,
    freeSpinInfo
  } = freeSpinStore;

  const reward: any = useMemo(() => freeSpinInfo?.[0] || {}, [freeSpinInfo]);

  const handleSeeAll = useCallback(() => {
    userActivityStore.sendTrackUserActivity({
      category: UserActivityCategory.PromoTools,
      type: UserActivityTypes.FreeSpinSideBarMenuCard
    });
    showAllFreeSpinRewards(freeSpinInfo);
    onClose();
  }, [showAllFreeSpinRewards, freeSpinInfo, onClose]);

  const handlePlayNow = useCallback(() => {
    showFreeSpinReward(reward);
    onClose();
  }, [showFreeSpinReward, reward, onClose]);

  return (
    <div className="boosted-jackpot-block free-spins">
      <div className="new-jackpot-block-header">
        <span className="new-jackpot-title">{translate(T.YOU_HAVE_RECEIVED)}</span>
        <button className="details-btn-new" type="button" onClick={handleSeeAll}>{translate(T.DETAILS)}</button>
      </div>
      <p className="jackpot-nsp-text free-spins-txt"><span className="free-spins-text-number">{formatValue(reward.remainingCount || reward.count)}</span>{translate(T.FREE_SPINS)}</p>
      <div className="jackpot-spin-amount">
        <p className="spin-amount">{translate(T.SPIN_AMOUNT)}</p>
        <p className="jackpot-nsp-text spin-amount-number">{formatValue(reward.amount) } {currencySymbol}</p>
      </div>
      <div className="jackpot-info-row">
        <p className="jackpot-date-info">{translate(T.CAN_BE_USED_UNTIL)}</p>
        <p className="jackpot-date">{formatDate(new Date(reward.expireDate))}</p>
      </div>
      <div className="jackpot-info-row">
        {
          reward.minOdd ? (
            <div className="jackpot-info-col">
              <p className="jackpot-date-info">{translate(T.MIN_ODD)}</p>
              <p className="jackpot-date">{formatValue(reward.minOdd)}</p>
            </div>
          ) : null
        }
        {
          reward.maxPayout ? (
            <div className="jackpot-info-col">
              <p className="jackpot-date-info">{translate(T.MAX_PAYOUT)}</p>
              <p className="jackpot-date">{formatValue(reward.maxPayout)}</p>
            </div>
          ) : null
        }
      </div>
      <button className="jackpot-free-spin-btn" type="button" onClick={handlePlayNow}>
        {translate(hasGameRedirection ? T.PLAY_NOW : T.CLAIM_NOW)}
      </button>
    </div>
  );
});
